
import React, {Component} from 'react';
import {Col,Modal,FormControl,Button,ButtonToolbar,Form,FormGroup,ControlLabel} from 'react-bootstrap'
// import Select from 'react-select'
// import WorkdocStore from '../../stores/WorkdocStore'
import CashflowStore  from '../../stores/CashflowStore';
import ConfirmPopup from '../../component/element/ConfirmPopup'
import FontAwesome from 'react-fontawesome';
const api = require('api')
const messages = api.getMessage().view.cashflow.IncentivePayeeEditModal
class IncentivePayeeEditModal extends Component {

  constructor(...args){
    super(...args)
    this.state = this.initItem()
  }

  initItem(){
    return {payee_code:'',first_name:'',last_name:'',tel:'',ie_payee_id:'',showConfirmDelete:false,bank_name:'',bank_account_no:''}
  }

  // componentWillReceiveProps(newProps){
  //   if(newProps.show && newProps.show !==this.props.show){
  //     this.loadItemcode(newProps.item)
  //   }
  // }

  loadItemcode(item){
    if(item!==null) {
      this.setState(Object.assign(this.state,item))
    } 
    else {
      this.setState(this.initItem());
    }
  }

  onTextChange(field,e){
    let state = this.state
    state[field] = e.target.value
    this.setState(state)
  }

  onSelectChange(value){
    // let {catSelect} = this.state

    this.setState({catSelect:value})
  }

  onDelClick(){
    this.setState({showConfirmDelete:true})
  }

  onConfirmDeleteClick() {
    let {ie_payee_id} = this.state
    CashflowStore.delIncentivePayee(ie_payee_id,(result) => {
      this.props.onAfterSubmit(ie_payee_id);
      this.props.onHide()
    })
    this.setState({showConfirmDelete:false})
  }

  onSaveClick(){
        
    let postData = this.state
    CashflowStore.saveIncentivePayee(postData,(result)=>{
      this.props.onAfterSubmit(postData)
      //this.props.onSearchAfterSubmit(postData)
      this.props.onHide()
    })
  }

  renderForm(){
    let {payee_code,first_name,last_name,tel,bank_name,bank_account_no} = this.state
    
    return(
      <div>
        <Form horizontal>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              {messages['Employee ID']}
            </Col>
            <Col sm={7}>
              <FormControl value={payee_code} onChange={this.onTextChange.bind(this,'payee_code')}/>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              {messages['First name']}
            </Col>
            <Col sm={7}>
              <FormControl value={first_name} onChange={this.onTextChange.bind(this,'first_name')}/>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              {messages['Last name']}
            </Col>
            <Col sm={7}>
              <FormControl value={last_name} onChange={this.onTextChange.bind(this,'last_name')}/>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              {messages['Phone']}
            </Col>
            <Col sm={7}>
              <FormControl  value={tel} onChange={this.onTextChange.bind(this,'tel')} />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              {messages['Bank account']}
            </Col>
            <Col sm={7}>
              <FormControl  value={bank_name} onChange={this.onTextChange.bind(this,'bank_name')} />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              {messages['Account number']}
            </Col>
            <Col sm={7}>
              <FormControl  value={bank_account_no} onChange={this.onTextChange.bind(this,'bank_account_no')} />
            </Col>
          </FormGroup>
        </Form>  
      </div>
    )
  }

  render(){
    let {show} = this.props
    let {ie_payee_id} = this.state

    let title = ''
    if(ie_payee_id===''){
      title = messages['Add claim employee in system']
    }else{
      title = messages['Edit claim employee']
    }
    return (
      <div>
        <Modal show={show} enforceFocus={false} onHide={this.props.onHide} dialogClassName="midwidth-dialog">
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.renderForm()}
          </Modal.Body>
          <Modal.Footer>
            <ButtonToolbar className='pull-right'>
            <Button style={{display:ie_payee_id===''?'none':''}} bsStyle={'danger'}  onClick={this.onDelClick.bind(this)}><FontAwesome name='eraser' />&nbsp;{messages['Delete']}</Button>
            <Button bsStyle={'primary'}  onClick={this.onSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;{messages['Save']}</Button>
            <Button onClick={this.props.onHide}><FontAwesome name='close' />&nbsp;{messages['Cancel']}</Button>
            </ButtonToolbar>
          </Modal.Footer>
        </Modal>
        <ConfirmPopup 
          show={this.state.showConfirmDelete}
          onHide={()=>this.setState({showConfirmDelete:false})}
          onConfirm={this.onConfirmDeleteClick.bind(this)}
          title={messages['Confirm delete']}
          confirmTitle={messages['Confirm delete']}
          message={messages['Do you want to confirm delete']}
        />
      </div>  
    )
  }
}

IncentivePayeeEditModal.defaultProps = {
  show : false
}

export default IncentivePayeeEditModal;





// WEBPACK FOOTER //
// ./src/view/cashflow/IncentivePayeeEditModal.js